import { writable } from 'svelte/store';
import { authAPI } from './api.js';

// User store
export const currentUser = writable(authAPI.getCurrentUser());

// Conversations store
export const conversations = writable([]);
export const selectedConversation = writable(null);

// Contacts store
export const contacts = writable([]);

// Labels store
export const labels = writable([]);

// Users store (for assignments)
export const users = writable([]);

// UI state
export const isLoading = writable(false);
export const errorMessage = writable(null);
export const successMessage = writable(null);

// Statistics
export const dashboardStats = writable({
    total_conversations: 0,
    open_conversations: 0,
    pending_conversations: 0,
    total_contacts: 0,
    total_messages: 0
});
